// Enum
import COLORS from '../enums/ColorEnum';

/**
 * Style du toastr
 */
export const notificationStyle = {
    NotificationItem: {
        success: {
            color: COLORS.WHITE,
            backgroundColor: COLORS.GREEN,
            borderTop: 'none'
        },
        error: {
            color: COLORS.WHITE,
            backgroundColor: COLORS.RED,
            borderTop: 'none'
        }
    },
    MessageWrapper: {
        DefaultStyle: {
            margin: 0,
            padding: 0,
            display: 'flex',
            height: '50px',
            fontSize: 'larger',
            fontWeight: 'bold',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },
    Dismiss: {
        DefaultStyle: {
            backgroundColor: 'transparent'
        }
    }
};



// WEBPACK FOOTER //
// ./src/utils/NotificationUtils.js